import React from 'react';
import { Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CreateProjectFab = () => {
  const navigate = useNavigate();
  const { isAdmin, isSuperAdmin } = useAuth();

  if (!isAdmin || isSuperAdmin) {
    return null;
  }

  return (
    <Tooltip title="Create project" placement="left">
      <button
        type="button"
        aria-label="Create project"
        onClick={() => navigate('/create')}
        style={{
          position: 'fixed',
          right: 28,
          bottom: 56,
          zIndex: 1100,
          width: 56,
          height: 56,
          borderRadius: '50%',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: '#fff',
          fontSize: 24,
          background: 'linear-gradient(135deg, #F62E97 0%, #94167F 45%, #153CB4 100%)',
          boxShadow: '0 10px 28px rgba(148, 22, 127, 0.45)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        }}
        onMouseEnter={(event) => {
          event.currentTarget.style.transform = 'translateY(-2px) scale(1.03)';
          event.currentTarget.style.boxShadow = '0 14px 32px rgba(148, 22, 127, 0.55)';
        }}
        onMouseLeave={(event) => {
          event.currentTarget.style.transform = 'none';
          event.currentTarget.style.boxShadow = '0 10px 28px rgba(148, 22, 127, 0.45)';
        }}
      >
        <PlusOutlined />
      </button>
    </Tooltip>
  );
};

export default CreateProjectFab;
